import React from "react"
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

import { HowToUsePlayer } from "@/shared/components/how-to-use"

interface Props {
  open: boolean
  onClose: () => void
}

const CalculatorTutorialDialog: React.FC<Props> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle sx={{ pr: 6 }}>
      How to Use the Meesho Profit Calculator
      <IconButton
        aria-label="Close Meesho calculator tutorial"
        onClick={onClose}
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Watch this walkthrough to learn how to calculate your Meesho profit.
      </Typography>
      <HowToUsePlayer />
    </DialogContent>
  </Dialog>
)

export default CalculatorTutorialDialog
